import { Component, OnInit } from '@angular/core'
import { User } from 'depoto-core/src/entities'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { CoreService } from '../../services'
import { usersColumns } from '../../utils/definitions.util'

const DEFAULT_FILTERS = {
  visible: false,
  expanded: false,
  email: '',
  sortProp: 'username',
  sortDir: 'asc',
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
})
export class UsersComponent extends BaseListing implements OnInit {
  listingColumns: ListingItem[] = usersColumns
  users: User[] = []
  totalItems = 0
  currentPage: number
  endPage: number
  filters = DEFAULT_FILTERS
  loading = true

  constructor(protected core: CoreService) {
    super(core)
    this.getStorageKey('users')
  }

  ngOnInit() {
    this.filters = this.loadViewSettings('users') || DEFAULT_FILTERS
    this.filter(1)
  }

  clearFilters(): void {
    this.filters.email = ''
    this.filter(1)
  }

  async filter(pageNo = 1, sortProp: string = this.sortProp, sortDir: string = this.sortDir, concat = false) {
    this.loading = true
    this.currentPage = pageNo
    if (!concat) {
      this.reloading = true
    }

    const options: any = {}
    if (this.filters.email && this.filters.email.length > 0) {
      options.email = this.filters.email
    }
    options.enabled = true
    const result = await this.core.services.user.getList(
      { filters: options, page: pageNo, sort: sortProp, direction: sortDir },
      {
        id: null,
        email: null,
        firstName: null,
        lastName: null,
      },
    )
    concat ? result?.items?.forEach(user => this.users.push(new User(user))) : (this.users = result?.items || [])
    this.totalItems = result?.paginator ? result?.paginator?.totalCount : 0
    this.endPage = result?.paginator ? result?.paginator?.endPage : 0
    this.loading = false
    this.reloading = false
    this.saveViewSettings('users', this.filters)
  }
}
